import React from 'react';
import { Logo } from '@deal/components';
import { usePathContext } from '../../context/PathContext.js';
import styles from './styles.css.js';

var LogoContainer = function LogoContainer(props) {
  var pathContext = usePathContext(); // Logo is never rendered within modal layouts

  if (pathContext.pathPlacement === 'modal') {
    return null;
  }

  return React.createElement("div", {
    className: styles.logo
  }, React.createElement(Logo, Object.assign({
    className: styles.logoMark
  }, props)));
};

export default LogoContainer;
//# sourceMappingURL=index.js.map
